import { apiGet, apiPost, apiDelete } from "./api";

function requireNonEmptyString(value, fieldName) {
  if (typeof value !== "string" || !value.trim()) {
    throw new Error(`${fieldName} is required.`);
  }

  return value.trim();
}

function requirePositiveInteger(value, fieldName) {
  if (!Number.isInteger(value) || value <= 0) {
    throw new Error(`${fieldName} must be a positive integer.`);
  }

  return value;
}

function normalizeInviteCode(inviteCode) {
  return requireNonEmptyString(inviteCode, "Invite code").toUpperCase();
}

// CREATE

export async function createLeague(name, userId, tournamentType = "PremierLeague", options = {}) {
  const trimmedName = requireNonEmptyString(name, "League name");
  const validUserId = requirePositiveInteger(userId, "User ID");

  return apiPost(
    "/Leagues",
    {
      name: trimmedName,
      userId: validUserId,
      tournamentType: tournamentType,
    },
    options
  );
}

// JOIN

export async function joinLeague(inviteCode, userId, options = {}) {
  const normalizedInviteCode = normalizeInviteCode(inviteCode);
  const validUserId = requirePositiveInteger(userId, "User ID");

  return apiPost(
    "/Leagues/join",
    {
      inviteCode: normalizedInviteCode,
      userId: validUserId,
    },
    options
  );
}

// GET USER LEAGUES

export async function getUserLeagues(userId, options = {}) {
  const validUserId = requirePositiveInteger(userId, "User ID");
  return apiGet(`/Leagues/user/${validUserId}`, options);
}

// GET LEAGUE

export async function getLeagueById(leagueId, options = {}) {
  const validLeagueId = requirePositiveInteger(leagueId, "League ID");
  return apiGet(`/Leagues/${validLeagueId}`, options);
}

// GET TABLE

export async function getLeagueTable(leagueId, options = {}) {
  const validLeagueId = requirePositiveInteger(leagueId, "League ID");
  return apiGet(`/Leagues/${validLeagueId}/table`, options);
}

// GET HISTORY

export async function getLeagueHistory(leagueId, userId, options = {}) {
  const validLeagueId = requirePositiveInteger(leagueId, "League ID");
  const validUserId = requirePositiveInteger(userId, "User ID");

  return apiGet(
    `/Leagues/${validLeagueId}/history?userId=${validUserId}`,
    options
  );
}

// GET GAMEWEEK DETAIL

export async function getLeagueGameweekDetail(
  leagueId,
  gameweekId,
  userId,
  options = {}
) {
  const validLeagueId = requirePositiveInteger(leagueId, "League ID");
  const validGameweekId = requirePositiveInteger(gameweekId, "Gameweek ID");
  const validUserId = requirePositiveInteger(userId, "User ID");

  return apiGet(
    `/Leagues/${validLeagueId}/history/gameweek/${validGameweekId}/user/${validUserId}`,
    options
  );
}

// DELETE
export async function deleteLeague(leagueId, userId, options = {}) {
  const validLeagueId = requirePositiveInteger(leagueId, "League ID");
  const validUserId = requirePositiveInteger(userId, "User ID");

  return apiDelete(
    `/Leagues/${validLeagueId}?userId=${validUserId}`,
    options
  );
}
// COPY PREDICTIONS TO OTHER LEAGUES

export async function copyPredictionsToOtherLeagues(userId, sourceLeagueId, gameweekId, options = {}) {
  const validUserId = requirePositiveInteger(userId, "User ID");
  const validLeagueId = requirePositiveInteger(sourceLeagueId, "League ID");
  const validGameweekId = requirePositiveInteger(gameweekId, "Gameweek ID");

  return apiPost(
    "/Predictions/copy-to-leagues",
    {
      userId: validUserId,
      sourceLeagueId: validLeagueId,
      gameweekId: validGameweekId
    },
    options
  );
}
